import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '@environment';
import {TranslateService} from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class KeycloakService {
  translations: any;
  systemMessage: string | null = null;

  constructor(
    private router: Router,
    private translateService: TranslateService,
  ) {
    this.translations = (this.translateService as any).store.translations[this.translateService.getFallbackLang()!];
  }

  initializeSystemMessage(): void {
    const systemMessage = this.translateService.instant('global.systemMessage.value');
    const validFromString = this.translateService.instant('global.systemMessage.validFrom');
    const validFrom = new Date(Date.parse(validFromString));
    const validToString = this.translateService.instant('global.systemMessage.validTo');
    const validTo = new Date(Date.parse(validToString));
    const today = new Date();
    if (validFrom <= today && validTo >= today) {
      this.systemMessage = systemMessage;
    }
  }

  login(stateUrl?: string): void {
    this.initializeSystemMessage();
    const loginUrl = new URL(environment.endpoints.keycloak);
    const url = stateUrl ?? '/';
    const parsedUrl = this.router.parseUrl(url);

    const queryParams = {...parsedUrl.queryParams};
    const calculationId = queryParams['calculationId'];
    const existingReturnUrl = queryParams['returnUrl'];
    const email = queryParams['email'];
    delete queryParams['calculationId'];
    delete queryParams['returnUrl'];
    delete queryParams['email'];
    delete queryParams['error'];

    let returnUrl: string | undefined;

    if (existingReturnUrl) {
      returnUrl = existingReturnUrl;
    } else {
      const pathSegments = parsedUrl.root.children['primary']?.segments.map(segment => segment.path) ?? ['/'];
      returnUrl = this.router.serializeUrl(this.router.createUrlTree(pathSegments, {queryParams}));
    }

    if (returnUrl && returnUrl !== '/') {
      returnUrl = returnUrl.replace('/login', '/');
      loginUrl.searchParams.set('returnUrl', returnUrl);
    }

    if (calculationId) {
      loginUrl.searchParams.set('calculationId', calculationId);
    }

    if (email) {
      loginUrl.searchParams.set('email', email);
    }

    if (this.systemMessage) {
      loginUrl.searchParams.set('message', this.systemMessage);
    }

    window.location.assign(loginUrl.toString());
  }
}
